import { useMutation, useQueryClient } from '@tanstack/react-query'
import { requestServices } from '../requestServices'
import { MutationRequestParams } from '../requestTypes'

export const useDeclineRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: MutationRequestParams) =>
      requestServices.declineRequest(params),
    onSuccess: () => {
      // Invalidate requests list to refresh data
      queryClient.invalidateQueries({ queryKey: ['payment-requests/history'] })
    },
  })
}

export const useCancelRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: MutationRequestParams) =>
      requestServices.cancelRequest(params),
    onSuccess: () => {
      // Invalidate requests list to refresh data
      queryClient.invalidateQueries({ queryKey: ['payment-requests/history'] })
    },
  })
}

export const useAcceptRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: MutationRequestParams) =>
      requestServices.acceptRequest(params),
    onSuccess: () => {
      // Invalidate requests list to refresh data
      queryClient.invalidateQueries({ queryKey: ['payment-requests/history'] })
    },
  })
}

export const useRemindRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: MutationRequestParams) =>
      requestServices.remindRequest(params),
    onSuccess: () => {
      // Invalidate requests list to refresh data
      queryClient.invalidateQueries({ queryKey: ['payment-requests/history'] })
    },
  })
}

export const useTakeBackRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: MutationRequestParams) =>
      requestServices.takeBackRequest(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payment-requests/history'] })
    },
  })
}
